/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    shape, string, number,
    bool, arrayOf, func,
} from 'prop-types';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Delete from '@material-ui/icons/Delete';
import Edit from '@material-ui/icons/Edit';
import ReactHTMLParser from 'react-html-parser';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Address from '../RecipientDetails/Address';
import Recommendation from '../RecipientDetails/Recommendation';
import ProductAddedToCart from '../RecipientDetails/ProductAddedToCart';
import ShopTheSite from '../RecipientDetails/ShopTheSite';
import AnimatedCheck from '../../../../assets/svg/AnimatedCheck';
import { isEmpty } from '../../../../utils/object';
import Spinner from '../../../../assets/svg/Spinner';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

class DesktopRecipientDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCollapse: false,
        };
    }

    setCollapseState = (isCollapse) => {
        this.setState({ isCollapse });
    }

    header = (addToCart, recipient) => (
        <>
            <div className="display-flex">
                {addToCart ? (
                    <AnimatedCheck className="success-color margin-right-half margin-bottom" />
                ) : (
                    ''
                )}
                <h2 className="margin-bottom-2x">
                    {recipient.firstname} {recipient.lastname}
                </h2>
            </div>
        </>
    );

    deliveryInfo = (recipient, isCollapse) => {
        if (!isEmpty(recipient.cartDetail || recipient.previousItemMetadata || recipient.holidayCode || recipient.holidayDesc)) return null;

        const productName = ReactHTMLParser(recipient.previousItemMetadata?.description || '');
        const productNumber = recipient.previousItemMetadata?.partNumber || '';
        const previousYearDesc = recipient?.holidayCode ? recipient?.holidayDesc : recipient.giftArrived;
        const currentPartNumber = recipient?.currentItempartNumber || '';

        if ((productName && productName.length) || productNumber) {
            if (recipient.giftArrived) {
                return (
                    <div className="deliveryInfo">
                        <div>Previously, you sent <span className="productSent">{productName} ({productNumber})</span> for arrival on <span className="productSent">{previousYearDesc}</span>.</div>
                        {!isCollapse ? (
                            <div>{
                                currentPartNumber === productNumber
                                    ? 'You can send this item again or choose a gift from our recommendations.'
                                    : 'Currently this product not available. Choose closest match or choose a gift from our recommendations below.'
                            }
                            </div>
                        ) : (
                            <div className="padding-bottom-2x">You can send this item again or choose a gift from our recommendations.</div>
                        )}
                    </div>
                );
            }
            // Currently show for TPF or CCO when doesnt have the delivery date
            return (
                <div className="deliveryInfo">
                    <div>Previously, you sent <span className="productSent">{productName} ({productNumber})</span>.</div>
                    {!isCollapse ? (
                        <div>{
                            currentPartNumber === productNumber
                                ? 'You can send this item again or choose a gift from our recommendations.'
                                : 'Product not available. Choose closest match or choose a gift from our recommendations below.'
                        }
                        </div>
                    ) : (
                        <div className="padding-bottom-2x">You can send this item again or choose a gift from our recommendations.</div>
                    )}
                </div>
            );
        }
        return (
            <div className={`deliveryInfo ${isCollapse ? 'padding-bottom-2x' : ''}`}>
                You can now choose a gift from our recommendations
                {!isCollapse ? ' below' : ''} or find something different using Enter Item Number or Shop the Site.
            </div>
        );
    };

    cardHeader = (recipient, onRemove, onEdit, isCollapse) => (
        <div className="cardHeader">
            <div className="recipientInfo">
                <div>{recipient.firstname} {recipient.lastname}</div>
                <Address recipient={recipient} />
            </div>
            {this.actionBlock(recipient, onRemove, onEdit, isCollapse)}
        </div>
    );

    actionBlock = (recipient, onRemove, onEdit, isCollapse) => {
        const { cartDetail } = recipient;
        const { handleTrackEvent } = this.props;
        const isAddedToCart = !isEmpty(cartDetail);
        return (
            <div className="actionBlock">
                <button
                    className={`collapse-btn icon-top ${isCollapse ? 'collapse' : ''} ${isAddedToCart ? 'display-none' : ''}`}
                    onClick={() => {
                        this.setCollapseState(!isCollapse);
                        handleTrackEvent({
                            eventCategory: 'Gift List V1',
                            eventAction: `Recipient Section ${isCollapse ? 'Expanded' : 'Collapsed'}`,
                            eventLabel: '',
                        });
                    }}
                    type="button"
                >
                    {isCollapse ? (
                        <>
                            <ExpandMore />
                            <span>Expand</span>
                        </>
                    ) : (
                        <>
                            <ExpandLess />
                            <span>Collapse</span>
                        </>
                    )}
                </button>
                <button
                    className="remove-recipient-btn icon-top"
                    onClick={() => {
                        onRemove(recipient, null, 'GIFT_LIST');
                        handleTrackEvent({
                            eventCategory: 'Gift List V1',
                            eventAction: 'Delete Recipient',
                            eventLabel: '',
                        });
                    }}
                    type="button"
                >
                    <Delete />
                    <span>Remove</span>
                </button>
                <button
                    className="edit-recipient-btn icon-top"
                    onClick={() => {
                        onEdit(recipient, 'desktop');
                        handleTrackEvent({
                            eventCategory: 'Gift List V1',
                            eventAction: 'Edit Recipient',
                            eventLabel: '',
                        });
                    }}
                    type="button"
                >
                    <Edit />
                    <span>Edit</span>
                </button>
            </div>
        );
    };

    renderLayout = ({
        recipient,
        onEdit, onRemove,
    }, isCollapse, checkProductClick, nonCheckProductClick, closestMatchProduct) => (
        <>
            {/* Card header: recipient, collapse, remove, edit */}
            {this.cardHeader(recipient, onRemove, onEdit, isCollapse)}
            {/* Card content */}
            <div className="cardContent">
                {/* Delivery info copy */}
                {this.deliveryInfo(recipient, isCollapse)}
                {/* Product Add to Cart template */}
                <ProductAddedToCart recipient={recipient} />
                {/* Product Recommendation carousel template */}
                <div className={`collapsable ${isCollapse ? 'collapse' : ''}`}>
                    {/* Carousel */}
                    <Recommendation
                        recipient={recipient}
                        checkProductClick={checkProductClick}
                        nonCheckProductClick={nonCheckProductClick}
                        closestMatchProduct={closestMatchProduct}
                    />
                    {/* Enter item number & Shop the site */}
                    <ShopTheSite
                        customClass="cardFooter"
                        recipient={recipient}
                    />
                </div>
            </div>
        </>
    );

    render() {
        // eslint-disable-next-line object-curly-newline
        const { recipient, checkProductClick, nonCheckProductClick } = this.props;
        const previousYearProduct = recipient?.previousItemMetadata?.partNumber;
        const currentPartNumber = recipient?.currentItempartNumber || '';
        const closestMatchProduct = currentPartNumber !== previousYearProduct;

        const { isCollapse } = this.state;
        if (isEmpty(recipient)) {
            return null;
        }
        return (
            <div className="cardLayout">
                {this.renderLayout(this.props, isCollapse, checkProductClick, nonCheckProductClick, closestMatchProduct)}
                <div className="spinner">
                    <Spinner />
                </div>
            </div>
        );
    }
}

DesktopRecipientDetails.defaultProps = {
    recipient: {},
};

DesktopRecipientDetails.propTypes = {
    handleTrackEvent: func.isRequired,
    recipient: shape({
        AddressBookEntryId: string,
        addToCart: string,
        address: shape({
            addressId: string,
            apt: string,
            city: string,
            company: string,
            country: shape({
                id: string,
                name: string,
            }),
            location: shape({
                id: number,
                name: string,
            }),
            state: shape({
                id: string,
                name: string,
            }),
            street: string,
            zipcode: string,
        }),
        addressId: string,
        firstname: string,
        giftArrived: string,
        id: string,
        isNewRecipient: bool,
        lastname: string,
        occasionId: string,
        orderItemId: string,
        products: arrayOf(
            shape({
                content: string,
                crossedPrice: string,
                discountPrice: string,
                id: string,
                image: string,
                name: string,
                parentCatalogEntryId: string,
                partNumber: string,
                price: number,
                seoproductDisplayURL: string,
                sku: string,
                status: string,
            }),
        ),
        type: string,
    }),
    checkProductClick: func.isRequired,
    nonCheckProductClick: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
    handleTrackEvent: bindActionCreators(trackEvent, dispatch),
});

export default connect(
    null,
    mapDispatchToProps,
)(DesktopRecipientDetails);
